export enum AssignmentCommitmentStatus {
  Optional = 'optional',
  Mandatory = 'mandatory',
  None = 'none',
}
